import { Component } from '@angular/core';

@Component({
    selector: 'aza-rws-shopping-cart-v2-order-items-card-view-row',
    templateUrl: 'shopping-cart-v2-order-items-card-view-row.component.html'
})
export class ShoppingCartV2OrderItemsCardViewRowComponent {

}
